
/**
 * Kijiji API
 */
export default class Kijiji {
  constructor(axios) {
    this.$axios = axios
  }

  Get() {
    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'get',
        url: '/publishers/kijiji',
      })
        .then(({ data }) => {
          resolve(data.kijiji)
        })
        .catch((err) => {
          if(err && err.response && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }

  Connect(username, password) {
    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'put',
        url: '/publishers/kijiji',
        data: { username, password }
      })
        .then(({ data }) => {
          resolve(data.kijiji)
        })
        .catch((err) => {
          if(err && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }

  Disconnect() {
    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'delete',
        url: '/publishers/kijiji',
      })
        .then(() => {
          resolve()
        })
        .catch((err) => {
          if(err && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }

  ListLocations() {
    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'get',
        url: '/publishers/kijiji/locations',
      })
        .then(({ data }) => {
          resolve(data.locations)
        })
        .catch((err) => {
          if(err && err.response && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }

  ListCategories() {
    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'get',
        url: '/publishers/kijiji/categories',
      })
        .then(({ data }) => {
          resolve(data.categories)
        })
        .catch((err) => {
          if(err && err.response && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }
}
